import React, { useState } from 'react';
import './TicketSection.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const tickets = {
  platinum: [
    {
      type: 'ULTIMATE EXPERIENCE',
      icon: 'fa-gem',
      short: 'The complete VIP package with all premium benefits.',
      details: [
        'Personal concierge service',
        'Luxury transportation',
        'All-access pass to every area',
        'Exclusive merchandise package'
      ],
      price: '$899',
      tag: 'ELITE'
    },
    {
      type: 'VIP TICKET',
      icon: 'fa-crown',
      short: 'Enjoy exclusive perks and premium access.',
      details: [
        'Backstage passes',
        'Private lounge access',
        'Priority entry',
        'Exclusive merchandise'
      ],
      price: '$249',
      tag: 'VIP'
    }
  ],
  gold: [
    {
      type: 'SEASON PASS',
      icon: 'fa-calendar-alt',
      short: 'Access to all events this season.',
      details: [
        'All matches and concerts',
        'Season holder lounge',
        '20% merch discount',
        'Early access to tickets'
      ],
      price: '$599',
      tag: 'BEST VALUE'
    },
    {
      type: 'MEET & GREET',
      icon: 'fa-handshake',
      short: 'Meet the players and artists.',
      details: [
        'Photo opportunity',
        'Autograph session',
        'Behind-the-scenes access',
        'Q&A session'
      ],
      price: '$349',
      tag: 'EXPERIENCE'
    }
  ],
  silver: [
    {
      type: 'PREMIUM SEATING',
      icon: 'fa-couch',
      short: 'Enhanced comfort seating experience.',
      details: [
        'Padded seats with legroom',
        'Dedicated concession access',
        'Premium viewing angles',
        'Commemorative ticket'
      ],
      price: '$179',
      tag: 'COMFORT'
    },
    {
      type: 'CONCERT TICKET',
      icon: 'fa-music',
      short: 'Attend the live eSports concert.',
      details: [
        'Front-row zone access',
        'Post-event concert',
        'Special souvenirs',
        'Artist meet-up chance'
      ],
      price: '$149',
      tag: ''
    },
    {
      type: 'DAY TICKET',
      icon: 'fa-calendar-day',
      short: 'Access all-day activities and matches.',
      details: [
        'Venue access all day',
        'Fan zones access',
        'Free merch item',
        'Food court discounts'
      ],
      price: '$99',
      tag: 'POPULAR'
    },
    {
      type: 'GROUP PACKAGE',
      icon: 'fa-users',
      short: 'Special rates for groups of 6+.',
      details: [
        'Custom group seating',
        'Group coordinator',
        '10% food discount',
        'Bulk merch discounts'
      ],
      price: '$54/person',
      tag: 'GROUP'
    },
    {
      type: 'GENERAL ADMISSION',
      icon: 'fa-ticket-alt',
      short: 'Standard event access.',
      details: [
        'Entry to the event',
        'General seating area',
        'Public facilities',
        'Merchandise stands'
      ],
      price: '$69',
      tag: ''
    },
    {
      type: 'STUDENT TICKET',
      icon: 'fa-graduation-cap',
      short: 'Special ticket for students.',
      details: [
        'Discounted entry',
        'General seating access',
        'Student-only areas',
        'Study zone access'
      ],
      price: '$49',
      tag: 'STUDENT'
    }
  ]
};

const TicketSection = () => {
  const [activeIndex, setActiveIndex] = useState({ platinum: null, gold: null, silver: null });

  const toggleDetails = (tier, index) => {
    setActiveIndex(prev => ({
      ...prev,
      [tier]: prev[tier] === index ? null : index
    }));
  };

  return (
    <div className="ticket-page">
      {/* Branded Header */}
      <div className="ticket-header-bar">
        <h1>Choose Your Ticket</h1>
      </div>

      <div className="ticket-pyramid">
        {/* Platinum Tier */}
        <div className="ticket-tier tier-platinum">
          <div className="tier-header">PLATINUM TIER</div>
          {tickets.platinum.map((ticket, index) => (
            <div
              className={`ticket platinum ${activeIndex.platinum === index ? 'active' : ''}`}
              key={`platinum-${index}`}
              onClick={() => toggleDetails('platinum', index)}
            >
              {ticket.tag && <span className="ticket-badge">{ticket.tag}</span>}
              <div className="ticket-header">
                <i className={`fas ${ticket.icon} ticket-icon`}></i>
                <h2>{ticket.type}</h2>
                <h3 className="ticket-price">{ticket.price}</h3>
              </div>
              <p className="ticket-short">{ticket.short}</p>
              {activeIndex.platinum === index && (
                <div className="ticket-details">
                  <ul>
                    {ticket.details.map((detail, i) => (
                      <li key={i}>{detail}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Gold Tier */}
        <div className="ticket-tier tier-gold">
          <div className="tier-header">GOLD TIER</div>
          {tickets.gold.map((ticket, index) => (
            <div
              className={`ticket gold ${activeIndex.gold === index ? 'active' : ''}`}
              key={`gold-${index}`}
              onClick={() => toggleDetails('gold', index)}
            >
              {ticket.tag && <span className="ticket-badge">{ticket.tag}</span>}
              <div className="ticket-header">
                <i className={`fas ${ticket.icon} ticket-icon`}></i>
                <h2>{ticket.type}</h2>
                <h3 className="ticket-price">{ticket.price}</h3>
              </div>
              <p className="ticket-short">{ticket.short}</p>
              {activeIndex.gold === index && (
                <div className="ticket-details">
                  <ul>
                    {ticket.details.map((detail, i) => (
                      <li key={i}>{detail}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Silver Tier */}
        <div className="ticket-tier tier-silver">
          <div className="tier-header">SILVER TIER</div>
          {tickets.silver.map((ticket, index) => (
            <div
              className={`ticket silver ${activeIndex.silver === index ? 'active' : ''}`}
              key={`silver-${index}`}
              onClick={() => toggleDetails('silver', index)}
            >
              {ticket.tag && <span className="ticket-badge">{ticket.tag}</span>}
              <div className="ticket-header">
                <i className={`fas ${ticket.icon} ticket-icon`}></i>
                <h2>{ticket.type}</h2>
                <h3 className="ticket-price">{ticket.price}</h3>
              </div>
              <p className="ticket-short">{ticket.short}</p>
              {activeIndex.silver === index && (
                <div className="ticket-details">
                  <ul>
                    {ticket.details.map((detail, i) => (
                      <li key={i}>{detail}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TicketSection;
